<div class="ab-list-item-inner flex w-100 activity-type--remove-entity">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-xmark"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user.name}}</span> removed <strong>{{item?.payload?.entity | fullName}}</strong> from the campaign.
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
